import { render } from "./ProductView.vue?vue&type=template&id=3252d220&scoped=true&ts=true"
import script from "./ProductView.ts?vue&type=script&lang=ts"
export * from "./ProductView.ts?vue&type=script&lang=ts"

import "./ProductView.scss?vue&type=style&index=0&id=3252d220&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3252d220"]])

export default __exports__